export default "__VITE_ASSET__4c0bf9f1__"